import {
  NEWS_LETTER_EMAIL_LOADING,
  NEWS_LETTER_EMAIL_SUCCESS,
  NEWS_LETTER_EMAIL_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { createNewItemService } from "services/createNewItemService";
import { notification } from "antd";
import { newsLetterUrl } from "api/apiUrls";

export const newsLetterActions = (data: any) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: NEWS_LETTER_EMAIL_LOADING, payload: true });
    const response: any = await createNewItemService(
      `${newsLetterUrl}`,
      data,
      "",
      "json"
    );

    dispatch({ type: NEWS_LETTER_EMAIL_SUCCESS, payload: response });
    if (response.status === 200) {
      notification.success({
        message: "Success",
      });
    } else {
      notification.error({
        message: `${response?.response?.data?.Message}`,
      });
    }
  } catch (err) {
    dispatch({ type: NEWS_LETTER_EMAIL_FAILURE, payload: err });
  } finally {
    dispatch({ type: NEWS_LETTER_EMAIL_LOADING, payload: false });
  }
};
